import { render, staticRenderFns } from "./CrmContactCard.vue?vue&type=template&id=9fa1d35c"
import script from "./CrmContactCard.vue?vue&type=script&lang=js"
export * from "./CrmContactCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports